import React from 'react'
import { useTranslation } from 'react-i18next'

const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61565911581944'

function Footer() {
  const { t } = useTranslation()

  return (
    <footer id="contact" className="site-footer">
      <div className="container">
        <p className="footer-tagline">{t('footer.tagline')}</p>
        <p className="footer-phone-block">
          <span className="footer-phone-label">{t('footer.phoneLabel')}</span>{' '}
          <a href="tel:+14694917604" className="footer-phone">{t('footer.phone')}</a>
        </p>
        <p className="footer-follow">
          {t('footer.followUs')}:{' '}
          <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">Facebook</a>
        </p>
        <p className="footer-copyright">{t('footer.copyright')}</p>
      </div>
    </footer>
  )
}

export default Footer
